import styles from "./styles.module.scss";
import cn from "classnames";

export const StatsBanner = ({ backgroundImage, stats, className }) => {
  return (
    <section
      className={cn(styles.StatsBanner, className)}
      style={{
        backgroundImage: `
          linear-gradient(180deg, rgba(1, 117, 80, 0.5) 0%, rgba(0, 34, 42, 0.5) 100%),
          url(${backgroundImage?.url})
        `,
      }}
    >
      <div className={styles.content}>
        {stats?.map(({ value, label }, idx) => (
          <div key={idx} className={styles.stat}>
            <div className={styles.value} data-sourceflow-prop={`stats[${idx}].value`}>
              {value}
            </div>
            <div className={styles.label} data-sourceflow-prop={`stats[${idx}].label`}>
              {label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsBanner;
